import { Data, Equivalence, BigNumber as BigNumber_ } from '@blade/std-lib';
export const TIME_RANGE_LANG_MAP = {
    '1S': 'common.price-range-1S',
    '1M': 'common.price-range-1M',
    '5M': 'common.price-range-5M',
    '15M': 'common.price-range-15M',
    '1H': 'common.price-range-1H',
    '4H': 'common.price-range-4H',
    '1D': 'common.price-range-1D',
    '1W': 'common.price-range-1W'
};
export var SwapOperation = /*#__PURE__*/ function(SwapOperation) {
    SwapOperation["Buy"] = "buy";
    SwapOperation["Sell"] = "sell";
    return SwapOperation;
}({});
export class DataHolderSwap extends Data.TaggedClass('DataHolderSwap') {
}
export class DataHolderMigration extends Data.TaggedClass('DataHolderMigration') {
    static Equivalence = Equivalence.Struct({
        actualTime: Equivalence.Date,
        price: BigNumber_.equivalence,
        marketCap: BigNumber_.equivalence,
        migrationTxHash: Equivalence.String
    });
}
export const getMinPrice = (priceData)=>{
    return Math.min(priceData.low, priceData.high, priceData.open, priceData.close);
};
export const getMaxPrice = (priceData)=>{
    return Math.max(priceData.low, priceData.high, priceData.open, priceData.close);
};
